import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserService } from '@app-services/user/user.service';
import { SetupAccountComponent } from '@app-shared/components/setup-account/setup-account.component';

@Component({
  selector: 'app-complete-profile',
  templateUrl: './complete-profile.component.html',
  styleUrls: ['./complete-profile.component.css']
})
export class CompleteProfileComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    private userService: UserService,
    private router:Router
  ) { }
  user: any;
  ngOnInit(): void {

    this.userService.loadUserDetails().subscribe((data) => {
      //console.log((data));
      if (data.isProfileComplete==true) {
        this.router.navigateByUrl('/dashboard');
      } else {
        const config: MatDialogConfig = {
          //width: '570px',
          maxWidth:"570px",
          //height: '100%',
          panelClass:'mat-full',
          data: { message: 'Set Up Your Account ', message2: `Please setup your account by entering your email ID and setting a password` }
        };
        const dialogRef = this.dialog.open(SetupAccountComponent, config);
        dialogRef.afterClosed().subscribe((value) => {
          if (value) {
          }
        });
      }
      
    }, err => {
      this.router.navigateByUrl('/dashboard');
    });


  }


}
